import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Adicione um vídeo seu do Youtube contando um pouco da sua experiência como profissional. ", -1)

import { computed, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { introVideoSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateUser } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntroVideo',
  setup(__props) {

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { handleSubmit, meta } = useForm({
  validationSchema: toTypedSchema(introVideoSchema),
  initialValues: { intro_video_link: "" },
});

const introVideoLinkModel = useVeeField("intro_video_link");
const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    const intro_video_link = values.intro_video_link.split("embed/")[1];
    await updateUser({ id: session.value!.id, intro_video_link });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_YoutubeInput = _resolveComponent("YoutubeInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_YoutubeInput, {
      label: "Link do Youtube",
      value: session.value?.formatted_intro_video_link,
      model: _unref(introVideoLinkModel)
    }, null, 8, ["value", "model"]),
    _createVNode(_component_FormButton, {
      label: "Concluir",
      loading: submitting.value,
      disabled: !_unref(meta).valid,
      onOnClick: _unref(submit)
    }, null, 8, ["loading", "disabled", "onOnClick"])
  ]))
}
}

})